var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "integrate-story-list-with-telegram-bot-modal",
        title: _vm.$t("chatbotv2.integrateStoryWithTelegram"),
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisible,
        footer: null,
      },
      on: {
        visibleChange: function (isVisible) {
          return _vm.$emit("modal-visible2", isVisible)
        },
        cancel: function ($event) {
          return _vm.handleCancel()
        },
      },
    },
    [
      _c(
        "a-form",
        {
          staticClass: "d-flex flex-column justify-content-center",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSave.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "col mb-5" },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("telegram.typeInTelegramToken") } },
                [
                  _c(
                    "a-modal",
                    {
                      attrs: {
                        title: "Do you really want to delete the token?",
                      },
                      on: {
                        ok: _vm.confirmDeleteToken,
                        cancel: _vm.cancelDeleteToken,
                      },
                      model: {
                        value: _vm.visibleDeleteToken,
                        callback: function ($$v) {
                          _vm.visibleDeleteToken = $$v
                        },
                        expression: "visibleDeleteToken",
                      },
                    },
                    [
                      !!this.selectedStory
                        ? _c("p", [
                            _vm._v(
                              "In that case integrated story will be revoked!"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", [_vm._v("The token will be lost permanently!")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mb-3" },
                    [
                      _c("a-input", {
                        staticClass: "mt-2",
                        class: { "err-class": _vm.showWarning },
                        attrs: {
                          autofocus: "",
                          placeholder: _vm.$t("telegram.token"),
                        },
                        on: { change: _vm.onChange },
                        model: {
                          value: _vm.tempToken,
                          callback: function ($$v) {
                            _vm.tempToken = $$v
                          },
                          expression: "tempToken",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: { label: _vm.$t("chatbotv2.selectIntegratingStory") },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row mb-3" },
                    [
                      _c(
                        "a-select",
                        {
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.selectedStory,
                            callback: function ($$v) {
                              _vm.selectedStory = $$v
                            },
                            expression: "selectedStory",
                          },
                        },
                        _vm._l(_vm.stories, function (story) {
                          return _c(
                            "a-select-option",
                            { key: story.id, attrs: { value: story.id } },
                            [
                              _vm._v(
                                _vm._s(story.title) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row justify-content-between" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-start" },
          [
            !!_vm.selectedStory
              ? _c(
                  "a-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.revokeDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("a-icon", {
                          staticClass: "px-1",
                          attrs: { type: "api" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.uninstall")) + "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-row justify-content-end" },
          [
            _c(
              "a-button",
              {
                staticClass: "mr-1 ant-btn-primary",
                attrs: { disabled: !_vm.isChangedStory || _vm.showWarning },
                on: {
                  click: function ($event) {
                    return _vm.handleOk()
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.install")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "ml-1",
                on: {
                  click: function ($event) {
                    return _vm.handleCancel()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.cancel")))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }